import React, { Component } from 'react'
import './styles.css'
import { Formik, Field, Form } from 'formik'
import Header from '../../../components/header'
import Rodape from '../../../components/rodape'
import loader from '../../../classes/loader'
import util from '../../../classes/util'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { apiEmployee } from '../../../services/apiamrg'
import moment from 'moment'
import ModalLogs from '../../../components/modalLogs'

const estadoInicial = {
    redirect: false,

    logs: [],
    modalLog: false,

    dadosIniciais: [],
    dadosFinais: [],

    acessos: [],
    permissoes: [],
    acessosPermissoes: [],

    chave: 0,
    nome: '',
    codigo: '',
    swift: '',
    endereco: '',
    beneficiario: '',
    cnpjCpf: '',
    agencia: '',
    conta: '',
    iban: '',
    pix: '',
    nomeCorrespondente: '',
    enderecoCorrespondente: '',
    contaCorrespondente: '',
    swiftCorrespondente: '',

    bloqueado: false,
}

class AddBanco extends Component {

    state = {
        ...estadoInicial,
        usuarioLogado: this.props.user
    }

    componentDidMount = async () => {
        window.scrollTo(0, 0)
        var id = await this.props.match.params.id
        await this.setState({ chave: id })
        if (parseInt(id) !== 0) {
            await this.setState({ banco: this.props.location.state.banco })
            await this.setState({
                nome: this.state.banco.Nome || '',
                codigo: this.state.banco.Codigo || '',
                swift: this.state.banco.Swift || '',
                endereco: this.state.banco.Endereco || '',
                beneficiario: this.state.banco.Beneficiario || '',
                cnpjCpf: this.state.banco.Cnpj_Cpf || '',
                agencia: this.state.banco.Agencia || '',
                conta: this.state.banco.Conta || '',
                iban: this.state.banco.Iban || '',
                pix: this.state.banco.Pix || '',
                nomeCorrespondente: this.state.banco.Nome_Correspondente || '',
                enderecoCorrespondente: this.state.banco.Endereco_Correspondente || '',
                contaCorrespondente: this.state.banco.Conta_Correspondente || '',
                swiftCorrespondente: this.state.banco.Swift_Correspondente || '',
            })
        }
        await this.carregaTiposAcessos()
        await this.carregaPermissoes()
        await this.testaAcesso()

        if (this.state.chave != 0) {
            await this.setState({
                dadosIniciais: [
                    { titulo: 'Nome', valor: util.formatForLogs(this.state.nome) },
                    { titulo: 'Código', valor: util.formatForLogs(this.state.codigo) },
                    { titulo: 'SWIFT', valor: util.formatForLogs(this.state.swift) },
                    { titulo: 'Endereço', valor: util.formatForLogs(this.state.endereco) },
                    { titulo: 'Beneficiário', valor: util.formatForLogs(this.state.beneficiario) },
                    { titulo: 'CNPJ/CPF', valor: util.formatForLogs(this.state.cnpjCpf) },
                    { titulo: 'Agência', valor: util.formatForLogs(this.state.agencia) },
                    { titulo: 'Conta', valor: util.formatForLogs(this.state.conta) },
                    { titulo: 'IBAN', valor: util.formatForLogs(this.state.iban) },
                    { titulo: 'PIX', valor: util.formatForLogs(this.state.pix) },
                    { titulo: 'Correspondente', valor: util.formatForLogs(this.state.nomeCorrespondente) },
                ]
            })

        }

        this.state.acessosPermissoes.map((e) => {
            if ((e.acessoAcao == "BANCOS" && e.permissaoInsere == 0 && this.state.chave == 0) || (e.acessoAcao == "BANCOS" && e.permissaoEdita == 0 && this.state.chave != 0)) {
                this.setState({ bloqueado: true })
            }
        })
    }

    carregaTiposAcessos = async () => {
        await apiEmployee.post(`getTiposAcessos.php`, {
            token: true,
        }).then(
            async res => {
                await this.setState({ acessos: res.data });
            },
            async err => { this.erroApi(err) }
        )
    }

    carregaPermissoes = async () => {
        await apiEmployee.post(`getPermissoes.php`, {
            token: true,
        }).then(
            async res => {
                await this.setState({ permissoes: res.data })
            },
            async err => { this.erroApi(err) }
        )
    }

    testaAcesso = async () => {
        let permissao = '';

        const acessosPermissoes = this.state.acessos.map((e, i) => {
            permissao = this.state.permissoes.filter((permissao) => {
                if (permissao.Usuario == this.state.usuarioLogado.codigo && permissao.Acessos == e.Chave && permissao.Empresa == this.state.usuarioLogado.empresa) {
                    return permissao;
                }
            })[0]
            return {
                acesso: e.Chave,
                acessoAcao: e.Acao,
                permissaoInsere: permissao ? permissao.Liberacao.split(``)[0] : 0,
                permissaoEdita: permissao ? permissao.Liberacao.split(``)[1] : 0,
                permissaoConsulta: permissao ? permissao.Liberacao.split(``)[2] : 0,
                permissaoDeleta: permissao ? permissao.Liberacao.split(``)[3] : 0
            }
        })

        await this.setState({ acessosPermissoes: acessosPermissoes });
    }

    salvarBanco = async (validForm) => {
        await this.setState({
            dadosFinais: [
                { titulo: 'Nome', valor: util.formatForLogs(this.state.nome) },
                { titulo: 'Código', valor: util.formatForLogs(this.state.codigo) },
                { titulo: 'SWIFT', valor: util.formatForLogs(this.state.swift) },
                { titulo: 'Endereço', valor: util.formatForLogs(this.state.endereco) },
                { titulo: 'Beneficiário', valor: util.formatForLogs(this.state.beneficiario) },
                { titulo: 'CNPJ/CPF', valor: util.formatForLogs(this.state.cnpjCpf) },
                { titulo: 'Agência', valor: util.formatForLogs(this.state.agencia) },
                { titulo: 'Conta', valor: util.formatForLogs(this.state.conta) },
                { titulo: 'IBAN', valor: util.formatForLogs(this.state.iban) },
                { titulo: 'PIX', valor: util.formatForLogs(this.state.pix) },
                { titulo: 'Correspondente', valor: util.formatForLogs(this.state.nomeCorrespondente) },
            ],
            loading: true
        })

        this.setState({ bloqueado: true })
        if (parseInt(this.state.chave) === 0 && validForm) {
            await apiEmployee.post(`insertBanco.php`, {
                token: true,
                Nome: this.state.nome,
                Codigo: this.state.codigo,
                Swift: this.state.swift,
                Endereco: this.state.endereco,
                Beneficiario: this.state.beneficiario,
                Cnpj_Cpf: this.state.cnpjCpf,
                Agencia: this.state.agencia,
                Conta: this.state.conta,
                Iban: this.state.iban,
                Pix: this.state.pix,
                Nome_Correspondente: this.state.nomeCorrespondente,
                Endereco_Correspondente: this.state.enderecoCorrespondente,
                Conta_Correspondente: this.state.contaCorrespondente,
                Swift_Correspondente: this.state.swiftCorrespondente,
            }).then(
                async res => {
                    if (res.data[0] && res.data[0].Chave) {
                        await this.setState({ chave: res.data[0].Chave })
                        await loader.salvaLogs('bancos', this.state.usuarioLogado.codigo, null, "Inclusão", res.data[0].Chave);
                        await this.setState({ loading: false, bloqueado: false })
                        this.props.history.goBack()
                    } else {
                        alert(`Erro: ${JSON.stringify(res)}`)
                    }
                },
                async res => await console.log(`Erro: ${res.data}`)
            )
        } else if (validForm) {
            await apiEmployee.post(`updateBanco.php`, {
                token: true,
                Chave: this.state.chave,
                Nome: this.state.nome,
                Codigo: this.state.codigo,
                Swift: this.state.swift,
                Endereco: this.state.endereco,
                Beneficiario: this.state.beneficiario,
                Cnpj_Cpf: this.state.cnpjCpf,
                Agencia: this.state.agencia,
                Conta: this.state.conta,
                Iban: this.state.iban,
                Pix: this.state.pix,
                Nome_Correspondente: this.state.nomeCorrespondente,
                Endereco_Correspondente: this.state.enderecoCorrespondente,
                Conta_Correspondente: this.state.contaCorrespondente,
                Swift_Correspondente: this.state.swiftCorrespondente,
            }).then(
                async res => {
                    if (res.data === true) {
                        await loader.salvaLogs('bancos', this.state.usuarioLogado.codigo, this.state.dadosIniciais, this.state.dadosFinais, this.state.chave, `BANCO: ${this.state.nome}`);
                        await this.setState({ loading: false, bloqueado: false })
                        this.props.history.goBack()
                    } else {
                        await alert(`Erro ${JSON.stringify(res)}`)
                    }
                },
                async res => await console.log(`Erro: ${res}`)
            )

        }

    }

    erroApi = async (res) => {
        console.log(res)
        await this.setState({ redirect: true })
    }

    openLogs = async () => {
        await this.setState({ logs: await loader.getLogs("bancos", this.state.chave) })
        await this.setState({ modalLog: true })
    }

    render() {

        const validations = []
        validations.push(this.state.nome)
        validations.push(!this.state.bloqueado)

        const validForm = validations.reduce((t, a) => t && a)

        return (
            <div className='allContent'>

                {this.state.redirect &&
                    <Redirect to={'/'} />
                }

                <section>
                    <Header voltarBancos titulo="Bancos" chave={this.state.chave != 0 ? this.state.chave : ''} />
                </section>

                {this.state.chave != 0 && this.state.acessosPermissoes.filter((e) => { if (e.acessoAcao == 'LOGS') { return e } }).map((e) => e.permissaoConsulta)[0] == 1 &&
                    <div className="logButton">
                        <button onClick={() => this.openLogs()}>Logs</button>
                    </div>
                }

                <ModalLogs
                    closeModal={() => { this.setState({ modalLog: false }) }}
                    logs={this.state.logs}
                    nome={this.state.nome}
                    chave={this.state.chave}
                    modalAberto={this.state.modalLog}
                />

                <div className="contact-section">

                    <div className="row">
                        <div className="col-lg-12">
                            <Formik
                                initialValues={{
                                    name: '',
                                }}
                                onSubmit={async values => {
                                    await new Promise(r => setTimeout(r, 1000))
                                    this.salvarBanco(validForm)
                                }}
                            >
                                <Form className="contact-form" >

                                    <div className="row">
                                        <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2"></div>

                                        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12 ">

                                            <div className="row addservicos">
                                                {this.state.chave != 0 &&
                                                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm firstLabel">
                                                        <label>Chave</label>
                                                    </div>
                                                }
                                                {this.state.chave != 0 &&
                                                    <div className='col-1'></div>
                                                }
                                                {this.state.chave != 0 &&
                                                    <div className="col-xl-2 col-lg-2 col-md-3 col-sm-10 col-10 ">
                                                        <Field className="form-control" style={{ backgroundColor: '#dddddd' }} type="text" disabled value={this.state.chave} />
                                                    </div>
                                                }
                                                {this.state.chave != 0 &&
                                                    <div className="col-xl-4 col-lg-4 col-md-3 col-sm-1 col-1 ">
                                                    </div>
                                                }
                                                
                                                <div className={this.state.chave == 0 ? "col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm firstLabel" : "col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm"}>
                                                    <label>Bank Name</label>
                                                </div>
                                                <div className='col-1 errorMessage'>
                                                    {!this.state.nome &&
                                                        <FontAwesomeIcon title='Preencha o campo' icon={faExclamationTriangle} />
                                                    }
                                                </div>
                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 ">
                                                    <Field className="form-control" type="text" value={this.state.nome} onChange={async e => { this.setState({ nome: e.currentTarget.value }) }} />
                                                </div>

                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                    <label>Bank Code</label>
                                                </div>
                                                <div className='col-1'></div>
                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 ">
                                                    <Field className="form-control" type="text" value={this.state.codigo} onChange={async e => { this.setState({ codigo: e.currentTarget.value }) }} />
                                                </div>

                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                    <label>SWIFT Code</label>
                                                </div>
                                                <div className='col-1'></div>
                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 ">
                                                    <Field className="form-control" type="text" value={this.state.swift} onChange={async e => { this.setState({ swift: e.currentTarget.value }) }} />
                                                </div>

                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                    <label>Address</label>
                                                </div>
                                                <div className='col-1'></div>
                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 ">
                                                    <Field className="form-control" type="text" value={this.state.endereco} onChange={async e => { this.setState({ endereco: e.currentTarget.value }) }} />
                                                </div>

                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                    <label>Account Name</label>
                                                </div>
                                                <div className='col-1'></div>
                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 ">
                                                    <Field className="form-control" type="text" value={this.state.beneficiario} onChange={async e => { this.setState({ beneficiario: e.currentTarget.value }) }} />
                                                </div>

                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                    <label>CNPJ</label>
                                                </div>
                                                <div className='col-1'></div>
                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 ">
                                                    <Field className="form-control" type="text" value={this.state.cnpjCpf} onChange={async e => { this.setState({ cnpjCpf: e.currentTarget.value }) }} />
                                                </div>

                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                    <label>Branch Number</label>
                                                </div>
                                                <div className='col-1'></div>
                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 ">
                                                    <Field className="form-control" type="text" value={this.state.agencia} onChange={async e => { this.setState({ agencia: e.currentTarget.value }) }} />
                                                </div>

                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                    <label>Account Number</label>
                                                </div>
                                                <div className='col-1'></div>
                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 ">
                                                    <Field className="form-control" type="text" value={this.state.conta} onChange={async e => { this.setState({ conta: e.currentTarget.value }) }} />
                                                </div>

                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                    <label>IBAN</label>
                                                </div>
                                                <div className='col-1'></div>
                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 ">
                                                    <Field className="form-control" type="text" value={this.state.iban} onChange={async e => { this.setState({ iban: e.currentTarget.value }) }} />
                                                </div>

                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                    <label>PIX</label>
                                                </div>
                                                <div className='col-1'></div>
                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 ">
                                                    <Field className="form-control" type="text" value={this.state.pix} onChange={async e => { this.setState({ pix: e.currentTarget.value }) }} />
                                                </div>

                                                <div className="center relatorioLabelTitulo" style={{ marginTop: '20px', marginBottom: '20px', color: 'white', fontWeight: 'bold !important', fontSize: '20px !important' }}>
                                                    <h5>Sender's Correspondent</h5>
                                                </div>

                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                    <label>Correspondent Name</label>
                                                </div>
                                                <div className='col-1'></div>
                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 ">
                                                    <Field className="form-control" type="text" value={this.state.nomeCorrespondente} onChange={async e => { this.setState({ nomeCorrespondente: e.currentTarget.value }) }} />
                                                </div>

                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                    <label>Correspondent Address</label>
                                                </div>
                                                <div className='col-1'></div>
                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 ">
                                                    <Field className="form-control" type="text" value={this.state.enderecoCorrespondente} onChange={async e => { this.setState({ enderecoCorrespondente: e.currentTarget.value }) }} />
                                                </div>

                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                    <label>Correspondent Account</label>
                                                </div>
                                                <div className='col-1'></div>
                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 ">
                                                    <Field className="form-control" type="text" value={this.state.contaCorrespondente} onChange={async e => { this.setState({ contaCorrespondente: e.currentTarget.value }) }} />
                                                </div>

                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                    <label>Correspondent SWIFT</label>
                                                </div>
                                                <div className='col-1'></div>
                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 ">
                                                    <Field className="form-control" type="text" value={this.state.swiftCorrespondente} onChange={async e => { this.setState({ swiftCorrespondente: e.currentTarget.value }) }} />
                                                </div>
                                            </div>



                                        </div>
                                        <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-1"></div>
                                    </div>

                                    <div className="row">
                                        <div className="col-2"></div>
                                        <div className="col-8" style={{ display: 'flex', justifyContent: 'center' }}>
                                            <button disabled={!validForm} type="submit" style={validForm ? { width: 300 } : { backgroundColor: '#eee', opacity: 0.3, width: 300 }} >Salvar</button>
                                        </div>
                                        <div className="col-2"></div>
                                    </div>

                                </Form>
                            </Formik>
                        </div>
                    </div>

                </div>
                <Rodape />
            </div>
        )

    }
}

const mapStateToProps = ({ user, servidor }) => {
    return {
        user: user,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(AddBanco)
